/**
 * Inline SVG for Editor.js {@link MenuConfig} `icon` fields.
 * Paths match react-icons/fi (Feather) so toolbar tunes align with the rest of the app.
 */
const fiAttrs =
  'xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"';

/** FiMessageCircle */
export const FI_MENU_ICON_MESSAGE_CIRCLE = `<svg ${fiAttrs}><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>`;

/** FiClipboard */
export const FI_MENU_ICON_CLIPBOARD = `<svg ${fiAttrs}><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/></svg>`;
